import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "doodle_fleche_court",
  "use": "doodle_fleche_court-usage",
  "viewBox": "0 0 96 94",
  "content": "<symbol viewBox=\"0 0 96 94\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"doodle_fleche_court\">\n<path d=\"M49.2484 68.9548L54.4551 91.2891L70.6519 77.937\" stroke=\"#DC3819\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<path d=\"M58.3129 79.5573C66.4939 57.3594 66.8195 41.0461 63.2537 29.3281\" stroke=\"#DC3819\" stroke-width=\"3\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/doodle_fleche_court.svg
// module id = 437
// module chunks = 0